module.exports = __webpack_public_path__ + "static/img/amazon.1e4cacbd.png";